import * as React from 'react';

function PremiumAlert(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="47" viewBox="0 0 47 47" width="47" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M39.7142 39.7142C43.8621 35.5663 46.4173 29.8279 46.4173 23.5007C46.4173 17.1757 43.8621 11.435 39.7142 7.28711C35.5663 3.13919 29.8279 0.583984 23.5007 0.583984C17.1757 0.583984 11.435 3.13919 7.28711 7.28711C3.13919 11.435 0.583984 17.1734 0.583984 23.5007C0.583984 29.8257 3.13919 35.5663 7.28711 39.7142C11.435 43.8621 17.1734 46.4173 23.5007 46.4173C29.8257 46.4173 35.5663 43.8621 39.7142 39.7142ZM26.6013 32.3396C26.6013 30.6209 25.2194 29.2413 23.5007 29.2413C21.7819 29.2413 20.3588 30.6232 20.3588 32.3396C20.3588 34.0584 21.7819 35.4838 23.5007 35.4838C25.2194 35.4838 26.6013 34.0584 26.6013 32.3396ZM23.5007 26.0971C22.3686 26.0971 21.5298 25.1759 21.4061 24.0025L20.3588 14.6617C20.1915 13.0277 21.9079 11.5152 23.5007 11.5152C25.0934 11.5152 26.8098 13.0254 26.6013 14.6594L25.5952 24.0002C25.4692 25.1736 24.6327 26.0948 23.5007 26.0948V26.0971Z"
        fill="#D82F20"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default PremiumAlert;
